(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["celestial-delivery-estimate"] && !Shopify.designMode) return;
  try {
    class CelestialDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.countdown = this.querySelector('[data-delivery-countdown]');
      this.date = this.querySelector('[data-delivery-date]');
      this.cutoffHour = Number(this.dataset.cutoffHour || 14);
      this.transitDays = Number(this.dataset.transitDays || 2);
      this.update();
      this.timer = window.setInterval(() => this.update(), 30000);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    update() {
      const now = new Date();
      const cutoff = new Date(now);
      cutoff.setHours(this.cutoffHour, 0, 0, 0);

      const dispatchDate = new Date(now);
      if (now >= cutoff) {
        cutoff.setDate(cutoff.getDate() + 1);
        dispatchDate.setDate(dispatchDate.getDate() + 1);
      }

      const deliveryDate = new Date(dispatchDate);
      deliveryDate.setDate(deliveryDate.getDate() + this.transitDays);

      const remaining = Math.max(0, cutoff.getTime() - now.getTime());
      const hours = Math.floor(remaining / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);

      if (this.countdown) this.countdown.textContent = `${hours}hr${hours === 1 ? '' : 's'} ${minutes}m`;
      if (this.date) {
        const day = deliveryDate.getDate();
        const suffix = day % 10 === 1 && day % 100 !== 11 ? 'st' : day % 10 === 2 && day % 100 !== 12 ? 'nd' : day % 10 === 3 && day % 100 !== 13 ? 'rd' : 'th';
        const weekday = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(deliveryDate);
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(deliveryDate);
        this.date.textContent = `${weekday} ${day}${suffix} ${month}`;
      }
    }
  }

  if (!customElements.get('celestial-delivery-estimate')) {
    customElements.define('celestial-delivery-estimate', CelestialDeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["celestial-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('celestial-mobile-purchase')) {
    customElements.define('celestial-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.product = this.closest('product-info');
        this.purchaseForm = this.closest('product-form');
        this.selectionButton = this.querySelector('button');
        if (!this.product || !this.purchaseForm || !this.selectionButton) return;
        this.sync = this.sync.bind(this);
        this.measure = this.measure.bind(this);
        this.changeSelection = this.changeSelection.bind(this);
        this.bindPreview = this.bindPreview.bind(this);
        this.selectionButton.addEventListener('click', this.changeSelection);
        this.product.addEventListener('change', this.sync);
        this.productObserver = new MutationObserver(this.sync);
        this.productObserver.observe(this.product, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
        this.resizeObserver = new ResizeObserver(this.measure);
        this.resizeObserver.observe(this.purchaseForm);
        this.bodyObserver = new MutationObserver(this.bindPreview);
        this.bodyObserver.observe(document.body, { childList: true });
        window.addEventListener('resize', this.measure);
        this.bindPreview();
        this.sync();
      }

      disconnectedCallback() {
        this.selectionButton?.removeEventListener('click', this.changeSelection);
        this.product?.removeEventListener('change', this.sync);
        this.productObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.bodyObserver?.disconnect();
        window.removeEventListener('resize', this.measure);
        document.documentElement.style.removeProperty('--celestial-purchase-height');
        document.documentElement.style.removeProperty('--celestial-preview-offset');
      }

      setText(node, value) {
        if (node && node.textContent !== value) node.textContent = value;
      }

      sync() {
        const picker = this.product.querySelector('variant-selects');
        const choices = picker ? Array.from(picker.querySelectorAll('input[type="radio"]:checked, select')).map(input => input.value) : [];
        if (choices.length) {
          this.setText(this.querySelector('[data-purchase-selection]'), choices.join(' · ').replace(/\b1\.2\*/g, '').replace(/(\d)mm\b/g, '$1 mm'));
        }
        const price = this.product.querySelector('.price');
        const currentPrice = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
        if (currentPrice) this.setText(this.querySelector('[data-purchase-price]'), currentPrice.textContent.replace(/\s+/g, ' ').trim());
        const submit = this.purchaseForm.querySelector('button[name="add"]');
        const payment = this.purchaseForm.querySelector('.shopify-payment-button');
        const disabled = !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true';
        if (payment && payment.inert !== disabled) payment.inert = disabled;
      }

      changeSelection() {
        const picker = this.product.querySelector('variant-selects');
        const control = picker?.querySelector('input[type="radio"]:checked, select');
        if (!picker) return;
        control?.focus({ preventScroll: true });
        picker.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      }

      bindPreview() {
        const preview = document.getElementById('PBarNextFrameWrapper');
        if (preview !== this.preview) {
          if (this.preview) this.resizeObserver.unobserve(this.preview);
          this.preview = preview;
          if (preview) this.resizeObserver.observe(preview);
        }
        this.measure();
      }

      measure() {
        const rect = this.preview?.getBoundingClientRect();
        const offset = rect && rect.height < innerHeight / 2 && rect.bottom >= innerHeight - 2 ? Math.ceil(rect.height) : 0;
        const root = document.documentElement;
        root.style.setProperty('--celestial-preview-offset', `${offset}px`);
        root.style.setProperty('--celestial-purchase-height', `${Math.ceil(this.purchaseForm.getBoundingClientRect().height)}px`);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["celestial-product-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('celestial-product-accordion')) {
    customElements.define('celestial-product-accordion', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.trigger = this.querySelector('summary');
        this.panel = this.querySelector('.celestial-product-accordion__panel');
        if (!this.details || !this.trigger || !this.panel || this.listeners) return;

        this.expanded = this.details.open;
        this.details.dataset.enhanced = 'true';
        this.syncAccessibility();
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };

        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.setExpanded(!this.expanded);
        }, options);

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.expanded) {
            event.preventDefault();
            this.setExpanded(false);
            this.trigger.focus({ preventScroll: true });
          }
        }, options);

        this.details.addEventListener('toggle', () => {
          if (this.heightAnimation) return;
          this.expanded = this.details.open;
          this.syncAccessibility();
        }, options);
      }

      syncAccessibility() {
        this.trigger.setAttribute('aria-expanded', String(this.expanded));
        this.panel.inert = !this.expanded;
      }

      cancelAnimations() {
        if (this.heightAnimation) {
          this.heightAnimation.onfinish = null;
          this.heightAnimation.cancel();
          this.heightAnimation = null;
        }
        if (this.panelAnimation) {
          this.panelAnimation.cancel();
          this.panelAnimation = null;
        }
      }

      finishTransition() {
        this.details.open = this.expanded;
        this.cancelAnimations();
        this.details.style.overflow = '';
        delete this.details.dataset.animating;
        this.syncAccessibility();
      }

      setExpanded(expanded) {
        const startHeight = this.details.getBoundingClientRect().height;
        const panelStyle = getComputedStyle(this.panel);
        const startOpacity = this.details.open ? panelStyle.opacity : '0';
        const startTransform = this.details.open ? panelStyle.transform : 'translateY(-5px)';
        this.cancelAnimations();
        this.expanded = expanded;
        this.syncAccessibility();

        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !this.details.animate) {
          this.finishTransition();
          return;
        }

        this.details.open = true;
        this.details.style.overflow = 'hidden';
        this.details.dataset.animating = 'true';
        const detailsStyle = getComputedStyle(this.details);
        const borders = parseFloat(detailsStyle.borderTopWidth) + parseFloat(detailsStyle.borderBottomWidth);
        const endHeight = this.trigger.getBoundingClientRect().height + borders +
          (expanded ? this.panel.getBoundingClientRect().height : 0);
        const easing = 'cubic-bezier(0.22, 1, 0.36, 1)';

        this.heightAnimation = this.details.animate(
          [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
          { duration: 580, easing }
        );
        this.panelAnimation = this.panel.animate(
          [
            { opacity: startOpacity, transform: startTransform },
            { opacity: expanded ? 1 : 0, transform: expanded ? 'translateY(0)' : 'translateY(-5px)' }
          ],
          { duration: expanded ? 420 : 260, easing, fill: 'both' }
        );
        this.heightAnimation.onfinish = () => this.finishTransition();
      }

      disconnectedCallback() {
        this.listeners?.abort();
        this.listeners = null;
        if (this.details) this.finishTransition();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["celestial-product-features"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.celestial-product-features-source').forEach((source) => {
    if (source.dataset.enhanced === 'true') return;
    const target = source.nextElementSibling;
    if (!target) return;

    source.dataset.enhanced = 'true';
    const raw = source.textContent.replace(/\r/g, '').trim();
    let blocks = raw.split(/\n\s*\n+/).filter(Boolean);
    if (blocks.length <= 1) blocks = raw.split(/(?=^\s*[•·-]\s+)/gm).filter(Boolean);

    blocks.forEach((block) => {
      const lines = block.split('\n').map((line) => line.trim()).filter(Boolean);
      if (!lines.length) return;

      const item = document.createElement('div');
      const title = document.createElement('h3');
      title.className = 'celestial-product-feature__title';
      title.textContent = lines.shift().replace(/^[•·-]\s*/, '');
      item.className = 'celestial-product-feature';
      item.appendChild(title);

      if (lines.length) {
        const description = document.createElement('p');
        description.className = 'celestial-product-feature__description';
        description.textContent = lines.join(' ');
        item.appendChild(description);
      }

      target.appendChild(item);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["celestial-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('celestial-product-video')) {
    customElements.define('celestial-product-video', class extends HTMLElement {
      connectedCallback() {
        if (this.listeners) return;
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.listeners = new AbortController();
        this.inView = false;
        this.autoEligible = false;
        this.userPaused = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.playsInline = true;

        this.sync = () => this.syncPlayback();
        this.video.addEventListener('pause', () => {
          if (this.autoEligible && !this.video.ended) this.userPaused = true;
        }, { signal: this.listeners.signal });
        this.video.addEventListener('play', () => {
          this.userPaused = false;
        }, { signal: this.listeners.signal });
        document.addEventListener('visibilitychange', this.sync, { signal: this.listeners.signal });
        this.motion.addEventListener('change', this.sync);

        this.observer = new IntersectionObserver((entries) => {
          const entry = entries[entries.length - 1];
          if (!entry) return;
          const nextInView = entry.isIntersecting && entry.intersectionRatio >= 0.25;
          if (nextInView === this.inView) return;
          this.inView = nextInView;
          if (!this.inView) this.userPaused = false;
          this.syncPlayback();
        }, { threshold: [0, 0.25] });
        this.observer.observe(this);
      }

      syncPlayback() {
        this.autoEligible = this.inView && !document.hidden && !this.motion.matches;
        if (!this.autoEligible) {
          this.video.pause();
          return;
        }
        if (this.userPaused || this.video.ended) return;
        const playing = this.video.play();
        if (playing) playing.catch(() => {});
      }

      disconnectedCallback() {
        this.autoEligible = false;
        if (this.video) this.video.pause();
        if (this.observer) this.observer.disconnect();
        if (this.motion && this.sync) this.motion.removeEventListener('change', this.sync);
        if (this.listeners) this.listeners.abort();
        this.listeners = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["senlan-placement-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('senlan-placement-navigation')) {
    customElements.define('senlan-placement-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.mobileMenu = this.querySelector('[data-mobile-menu]');
        this.desktopMenus = [...this.querySelectorAll('[data-desktop-menu]')];
        this.addEventListener('toggle', (event) => this.onToggle(event), { capture: true, signal });
        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-close-menu]')) this.closeAll(true);
          else if (event.target.closest('a')) this.closeAll(false);
        }, { signal });
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (this.isConnected && !this.contains(document.activeElement)) this.closeAll(false);
          });
        }, { signal });
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.closeAll(false);
        }, { signal });
        window.addEventListener('resize', () => {
          if (window.innerWidth >= 990 && this.mobileMenu.open) this.closeAll(false);
          if (window.innerWidth < 990) this.desktopMenus.forEach((menu) => { menu.open = false; });
          this.updatePosition();
        }, { signal });
      }

      disconnectedCallback() {
        this.closeAll(false);
        this.controller?.abort();
      }

      updatePosition() {
        const header = this.closest('header');
        if (header) this.style.setProperty('--senlan-menu-top', `${Math.max(0, Math.round(header.getBoundingClientRect().bottom))}px`);
      }

      onToggle(event) {
        const menu = event.target;
        if (!(menu instanceof HTMLDetailsElement)) return;
        menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(menu.open));
        if (menu.matches('[data-desktop-menu]') && menu.open) {
          this.desktopMenus.forEach((other) => { if (other !== menu) other.open = false; });
        }
        if (menu === this.mobileMenu) {
          document.documentElement.classList.toggle('senlan-navigation-open', menu.open);
          this.updatePosition();
        }
        if (menu.open && !menu.matches('[data-mobile-group]')) {
          this.closest('header')?.querySelectorAll('.senlan-home-search[open]').forEach((search) => { search.open = false; });
        }
      }

      closeAll(restoreFocus = false) {
        const openMenu = this.mobileMenu?.open ? this.mobileMenu : this.desktopMenus?.find((menu) => menu.open);
        this.querySelectorAll('details[open]').forEach((menu) => {
          menu.open = false;
          menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
        });
        document.documentElement.classList.remove('senlan-navigation-open');
        if (restoreFocus) openMenu?.querySelector(':scope > summary')?.focus();
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          this.closeAll(true);
          return;
        }
        const trigger = event.target.closest('.senlan-placement-trigger');
        if (!trigger || window.innerWidth < 990) return;
        const triggers = [...this.querySelectorAll('.senlan-placement-trigger')];
        const index = triggers.indexOf(trigger);
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? triggers.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + triggers.length) % triggers.length;
          this.desktopMenus.forEach((menu) => { menu.open = false; });
          triggers[next]?.focus();
        } else if (event.key === 'ArrowDown' && trigger.tagName === 'SUMMARY') {
          event.preventDefault();
          trigger.parentElement.open = true;
          trigger.parentElement.querySelector('.senlan-mega-panel a')?.focus();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
